import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {Button} from '../../button/button';
// @ts-expect-error
import {Level, StatusBadge} from '../../status-badge/status-badge';

import styles from './tertiary-action.module.css';

export type TertiaryActionPropsButton = {
    type: 'icon-button';
    icon: React.ComponentType<any>;
    onClick: (e: React.SyntheticEvent<any>) => void;
    color?: string;
    tootlipText?: string;
    getRef?: (arg1?: HTMLElement | null | undefined) => void;
    anchorElementId?: string;
};

type TertiaryActionPropsLink = {
    type: 'text-button';
    text: string;
    onClick?: (arg1: PointerEvent) => void;
};

type TertiaryActionPropsBadge = {
    type: 'badge';
    level: Level;
    text: string;
    detail?: string;
    icon?: React.ReactNode;
};

export type TertiaryActionProps =
    | TertiaryActionPropsButton
    | TertiaryActionPropsLink
    | TertiaryActionPropsBadge;

export function TertiaryAction(props: TertiaryActionProps) {
    if (props.type === 'text-button') {
        return (
            <Button
                variant='text-primary'
                preventUnderline={true}
                // @ts-expect-error
                onClick={props.onClick}
                noPadding={true}
                size='small'
            >
                {props.text}
            </Button>
        );
    }

    if (props.type === 'icon-button') {
        const Icon = props.icon;

        return (
            <button
                type='button'
                onClick={(e) => {
                    e.stopPropagation();

                    if (props.tootlipText) {
                        ReactTooltip.hide();
                    }

                    props.onClick(e);
                }}
                data-tip={props.tootlipText}
                ref={props.getRef}
                id={props.anchorElementId}
                className={styles['tertiary-action-button']}
            >
                <Icon size={16} color={props.color} fill={props.color} />
            </button>
        );
    }

    if (props.type === 'badge') {
        return (
            <StatusBadge
                size='small'
                customIcon={props.icon}
                level={props.level}
                text={props.text}
                detail={props.detail}
            />
        );
    }

    return null;
}
